import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { AgGridAngular } from 'ag-grid-angular';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ICustomer } from '@ruby/modules/customer-select/models/customer.interface';
import { ITrackMovePayload } from '@ruby/modules/track-move/models/track-move.interface';
import { fromTrackMove, TrackMoveActions, TrackMoveSelectors } from '@ruby/modules/track-move/store';
import { ITrack } from '@ruby/shared/models/inventory-management/inventory-header.interface';

@Component({
  selector: 'ng-to-track-header-container',
  templateUrl: './to-track-header.container.html',
  styleUrls: ['./to-track-header.container.scss']
})
export class ToTrackHeaderContainerComponent {
  @Input() toTrackGrid!: AgGridAngular;
  @Input() fromTrackGrid!: AgGridAngular;
  @Input() selectedToTrack?: ITrack;
  selectedFromTrack?: ITrack;
  customerSelected!: ICustomer;
  store$: Observable<{ trackMoveState: fromTrackMove.State; customerSelected?: ICustomer; userRacf?: string; performTrackMoves?: boolean }>;

  constructor(private store: Store<fromTrackMove.State>) {
    this.store$ = this.store.select(TrackMoveSelectors.selectTrackMoveWithAuth).pipe(
      tap((st: { customerSelected?: ICustomer; userRacf?: string; trackMoveState: fromTrackMove.State }) => {
        if (st.customerSelected && (this.customerSelected !== st.customerSelected)) {
          this.customerSelected = st.customerSelected;
        }
      })
    );
  }

  /**
   * Dispatch
   *
   * @summary Dispatches selected inventory
   * @param $request: { fromTrackEquipments: Array<string>, toTrackEquipments: Array<string>, payload: ITrackMovePayload }
   * @returns void
   */
  dispatch($request: { fromTrackEquipments: Array<string>; toTrackEquipments: Array<string>; payload: ITrackMovePayload }): void {
    this.store.dispatch(TrackMoveActions.setFromTrackEquipments({ data: $request.fromTrackEquipments }));
    this.store.dispatch(TrackMoveActions.setToTrackEquipments({ data: $request.toTrackEquipments }));
    this.store.dispatch(TrackMoveActions.adjustTrack({ data: $request.payload }));
  }
}
